import React from "react"
import PropTypes from "prop-types"
import COMPONENTS from "utils/componentConstants"
import SECTIONS from "utils/sectionConstants"
import SplitSection from "components/sections/splitSection"
import DynamicSection from "components/sections/dynamicSection"
import Gallery from "views/gallery"
import SectionInfoCardGrid from "components/sections/sectionInfoCardGrid"
import SectionTeamTestimonial from "components/sections/sectionTeamTestimonial"
import SectionExploreRoles from "components/sections/sectionExploreRoles"
import SectionReferralActions from "components/sections/sectionReferralActions"

const SectionRenderer = ({ section }) => {
  switch (section.__typename) {
    case COMPONENTS.SplitContent:
      return <SplitSection {...section} />
    case SECTIONS.DynamicSection:
      return <DynamicSection data={section} />
    case SECTIONS.TemplateDetailsSection:
      return <Gallery gallery={section.gallery} />
    case SECTIONS.InfoCardGrid:
      return <SectionInfoCardGrid {...section} />
    case SECTIONS.TeamTestimonial:
      return <SectionTeamTestimonial {...section} />
    case SECTIONS.SectionExploreRoles:
      return <SectionExploreRoles {...section} />
    case SECTIONS.SectionReferralActions:
      return <SectionReferralActions {...section} />
    default:
      return null
  }
}

const CareersPage = ({ gallery, sections }) => {
  return (
    <>
      {sections.map((section, i) => (
        <SectionRenderer key={i} section={section} />
      ))}
    </>
  )
}

SectionRenderer.propTypes = {
  section: PropTypes.shape({
    __typename: PropTypes.string.isRequired,
    gallery: PropTypes.object,
  }).isRequired,
}

CareersPage.propTypes = {
  gallery: PropTypes.object,
  sections: PropTypes.arrayOf(PropTypes.object).isRequired,
  slug: PropTypes.string,
  title: PropTypes.string,
}

export default CareersPage
